import { useSelector } from "react-redux";
import "./modalFooter.css"
import { CircularProgress } from "@mui/material";

interface ModalFooterProps { isValid: boolean, actionText: string, loadingText: string, closingText: string, handleSubmit: () => void, handleClose: () => void, modal: string, loader: boolean }

const ModalFooter = ({ isValid, actionText, loadingText, closingText, handleSubmit, handleClose, modal, loader }: ModalFooterProps) => {

    const creatingConstellation = useSelector((state: { missionModelling: { creatingConstellation: boolean } }) => state.missionModelling.creatingConstellation)

    return (
        <div className="modalFooter">
            <button
                disabled={loader}
                className={`modalFooterclose ${(!loader) ? '' : 'disable_analysis_button'}`}
                onClick={() => { handleClose() }}
            >
                {closingText}
            </button>
            <button
                disabled={loader}
                className={`modalFooterapply ${(isValid && !loader) ? '' : 'disable_analysis_button'}`}
                onClick={() => { isValid && handleSubmit() }}
            >
                {loader ? loadingText : actionText}
                {loader && < CircularProgress size={10} className="text-white" />}
            </button>
        </div>
    )
};

export default ModalFooter;